import type { Mode, SchemaData } from '../schema/types'

/**
 * A station snapshot placed where the map of `mode` draws it (TASK-1136): in
 * night mode at the late-night frame's marker (`station.night`) when it moves
 * the stop, otherwise at the day `x`/`y`. A snapshot taken in one mode keeps
 * its pin on the station after a flip. Returns the same reference when
 * nothing moves (no schema, unknown station, same point) so memoised
 * consumers do not re-render.
 */
export function stationInMode<T extends { id: string; canvasX: number; canvasY: number }>(
  snapshot: T | null,
  schema: SchemaData | null,
  mode: Mode,
): T | null {
  if (snapshot === null || schema === null) return snapshot
  const station = schema.stations.find((s) => s.id === snapshot.id)
  if (station === undefined) return snapshot
  const point = mode === 'night' && station.night !== undefined ? station.night : station
  if (point.x === snapshot.canvasX && point.y === snapshot.canvasY) return snapshot
  return { ...snapshot, canvasX: point.x, canvasY: point.y }
}
